import { IFilmOrderListItem } from '../Entities';

export const FilmTypeAll = -1;
export const FilmTypeRegular = 0;
export const FilmTypeSoMeFilm = 1;

export function filterByFilmType(
    orders: IFilmOrderListItem[],
    filmType: number | string
): IFilmOrderListItem[] {
    const selected = Number(filmType);

    if (selected === FilmTypeSoMeFilm) {
        return orders.filter((x) => x.hasSoMeFilm);
    }

    if (selected === FilmTypeRegular) {
        return orders.filter((x) => x.hasRegularFilm);
    }

    return orders;
}
